import React from "react";
import ProductCard from "../components/ProductCard";
import ProductCardSingle from "../components/ProductCardSingle";

export default function ListProducts({ products }) {
    return (
        <>
            {products.map((product, i) => (
                <ProductCardSingle key={i} product={product} />
            ))}
        </>
    );
}
